import { MainAttachments, type MainAttachmentsSkin } from '@/deskUiSkeletons/Page/MainAttachments'

const galleryMainAttachmentsSkin: MainAttachmentsSkin = {
  empty: 'flex min-h-[320px] items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white text-sm text-slate-500',
  root: 'flex min-h-0 w-full flex-1 flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-5 text-slate-900 shadow-sm',
  header: 'flex items-center justify-between border-b border-slate-200 pb-3',
  title: 'text-lg font-semibold',
  count: 'rounded-full bg-violet-100 px-2 py-1 text-xs font-semibold text-violet-700',
  body: 'grid min-h-0 flex-1 grid-cols-[minmax(0,1fr)_180px] gap-4 max-[720px]:grid-cols-1',
  preview: 'flex min-h-[320px] items-center justify-center overflow-hidden rounded-xl bg-slate-100 p-3',
  image: 'max-h-[75vh] max-w-full object-contain',
  side: 'flex min-h-0 flex-col gap-3',
  meta: 'rounded-xl border border-slate-200 p-3',
  metaTitle: 'break-words text-sm font-semibold',
  metaDescription: 'mt-1 break-words text-xs leading-5 text-slate-500',
  nav: 'flex gap-2',
  button: 'flex-1 rounded-lg bg-violet-600 px-2 py-2 text-xs font-semibold text-white hover:bg-violet-700',
  thumbs: 'grid max-h-[calc(75vh-120px)] grid-cols-2 gap-2 overflow-auto pr-1',
  thumb: 'rounded-lg border p-1',
  thumbSelected: 'border-violet-600 bg-violet-50',
  thumbUnselected: 'border-slate-200 bg-white',
  thumbImage: 'h-16 w-full rounded object-cover',
}

export function GalleryMainAttachments() {
  return <MainAttachments skin={galleryMainAttachmentsSkin} />
}
